











import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    Info: () => import('@/components/Info.vue')
  }
})
export default class Footer extends Vue {}
